import { ImgPipe } from './../shared/pipes/img.pipe';
import { Component, HostListener, OnInit, OnDestroy, AfterViewInit, Inject, PLATFORM_ID, ChangeDetectionStrategy, ChangeDetectorRef, NgZone, ViewChild, LOCALE_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OfferService } from '../offer/offer.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Page, Slide } from '../shared/navigation/pages.model';
import { environment } from '../../environments/environment';
import { Popup } from '../shared/navigation/pages.model';
import { Collection, Product } from './../offer/offer.model';
import { CartService } from '../shared/cart/cart.service';
import { Discount } from '../shared/cart/cart.model';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { SwiperComponent } from 'swiper/angular';
import { AuthService } from '../shared/auth/auth.service';

// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'h/ScrollTrigger';
SwiperCore.use([Navigation, Pagination, Autoplay]);

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ImgPipe]
})

export class HomeComponent implements OnInit, OnDestroy {
  public isMobile = true;
  public isLogged = false;
  public pageTitle: string;
  public pageContent: string;
  public offer_temp: Page[] = [];
  public offer: Page[] = [];
  public offerVisible = false;
  public aboutVisible = false;
  public collection: Collection;
  public collections: Collection[];
  public cdn = environment.cdn;
  public slides: Slide[] = [];
  public slides_sections: any[] = [];
  public active_slide = 0;
  public discounts: Discount[] = [];
  public products_featured: Product[] = [];
  public products_new: Product[] = [];
  public popup: Popup;
  public settings: any;
  public sub: Subscription = null;
  public path_offer = '';
  public path_offer_detail = '';
  public path_contact  = '';
  public path_about  = '';
  public path_career = '';
  public path_dealers = '';
  public path_configurator = '';
  public path_collections = '';
  public path_blog = '';
  public video = false;
  public video_urls = [];

  public pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '"></span>';
    },
  };

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.changeVisibility();
  }

  constructor(@Inject(PLATFORM_ID) private platformId: Object, @Inject(LOCALE_ID) public localeId: string, private auth: AuthService, private router: Router, private route: ActivatedRoute,
    private navigationService: NavigationService, private cartService: CartService, private offerService: OfferService,
    private zone: NgZone, private cdr: ChangeDetectorRef, private sanitizer: DomSanitizer) {
      this.path_contact = this.router.config.find(x => x.data?.module === 'ContactModule')?.path || '/';
      this.path_offer = this.router.config.find(r => r.data?.module === 'OfferModule' && +r.data.level === 0)?.path || '/';
      this.path_offer_detail = this.router.config.find(r => r.data?.module === 'OfferDetailsModule')?.path || '/';
      this.path_about = this.router.config.find(x => x.data?.template === 'lazy1.component')?.path || '/';
      this.path_career = this.router.config.find(x => x.data?.module === 'FormsModule')?.path || '/';
      this.path_dealers = this.router.config.find(x => x.data?.module === 'DistributorsModule')?.path || '/';
      this.path_collections = this.router.config.find(x => x.data?.module === 'CollectionsModule')?.path || '/';
      const filtered_article_pages = this.router.config.filter(r => r?.data?.module === 'ArticleModule');
      if (filtered_article_pages.length) {
      this.path_blog = filtered_article_pages.reduce((prev, curr) => (prev.data.level < curr.data.level) ? prev : curr)?.path || '/';
      }
      this.collection = new Collection();
      this.collection.id = -1;
      this.collection.homepage = 2;
      this.collection.loading = true;

      const tempCollectionSmall = new Collection();
      tempCollectionSmall.id = -1;
      tempCollectionSmall.homepage = 1;
      tempCollectionSmall.loading = true;
      this.collections = [tempCollectionSmall, tempCollectionSmall];

      const tempProduct = new Product();
      tempProduct.id = -1;
      this.products_featured = Array(4).fill(tempProduct);

  }

  changeVisibility() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth < 599) {
        this.isMobile = true;
      } else if (window.innerWidth > 599 && window.innerWidth < 1279) {
        this.isMobile = false;
      } else {
        this.isMobile = false;
      }
    }
  }

  ngOnInit() {
    this.sub = this.navigationService.navigation.subscribe(this.pageChanged);
    this.pageTitle = this.route.snapshot.data.name;
    this.pageContent = this.route.snapshot.data.content;

    this.changeVisibility();
    this.fetchSlides();
    if (isPlatformBrowser(this.platformId)) {
      this.fetchPopups();
    }
  }

  slideTo(i: number) {
    if (this.swiper) {
      this.swiper.swiperRef.slideTo(i, 300);
      this.active_slide = i;
    }
  }

  onSwiper([swiper]) {
    console.log(swiper);
  }
  onSlideChange() {
    if (this.swiper) {
      this.active_slide = this.swiper.swiperRef.activeIndex;
      this.cdr.detectChanges();
    }
  }

  fetchPopups() {
    if (isPlatformBrowser(this.platformId)) {

      let type = 'b2c';
      if (this.auth.loggedIn()) {
        type = 'b2b';
      }
      this.navigationService.popup({ type: type }).pipe(take(1)).subscribe(popup => {
        if (localStorage.getItem('popup_' + popup.id) === null) {
          this.popup = popup;
          this.cdr.markForCheck();
        }
      }, error => {
        // console.log(error);
      });
    }
  }

  hidePopup() {
    localStorage.setItem('popup_' + this.popup.id, 'true');
    this.popup = null;
  }

  fetchSlides() {
    //{ type: 'home' }
    this.navigationService.slides({}).pipe(take(1)).subscribe(s => {

      if (!s.items) return [];
      // let main_photo_for_pagespeed = true;
      s.items.forEach(slide => {
        switch (slide.type) {
          case 'b2b': {
            // console.log('b2b');
            if (this.auth.loggedIn() && this.slides.length < 3) {
              this.slides.push(slide);
            } 
            break;
          }
          case 'home': {
            // if (main_photo_for_pagespeed) {
            //   let imgLink = this.imgPipe.transform(slide, 'mobile', 'webp');
            //   if (!this.isMobile) {
            //     imgLink = this.imgPipe.transform(slide, 'desktop', 'webp');
            //   }
            //   this.navigationService.setLink(imgLink);
            //   main_photo_for_pagespeed = false;
            // }
            if (this.slides.length < 3) this.slides.push(slide);
            break;
          }
          case 'section_1': {
            if (!this.slides_sections[0]) this.slides_sections[0] = [];
            this.slides_sections[0].push(slide);
            break;
          }
          case 'section_2': {
            if (!this.slides_sections[1]) this.slides_sections[1] = [];
            this.slides_sections[1].push(slide);
            break;
          }
          case 'section_3': {
            if (!this.slides_sections[2]) this.slides_sections[2] = [];
            this.slides_sections[2].push(slide);
            break;
          }
          case 'section_4': {
            if (!this.slides_sections[3]) this.slides_sections[3] = [];
            this.slides_sections[3].push(slide);
            break;
          }
          case 'section_5': {
            if (!this.slides_sections[4]) this.slides_sections[4] = [];
            this.slides_sections[4].push(slide);
            break;
          }
        }
      });
      this.cdr.detectChanges();
    }, error => {
      // console.log(error);
    });
  }

  fetchFeatured() {
    this.offerService.items({ limit: 16, rand: true, day: true }).pipe(take(1)).subscribe(result => {
      this.zone.run(() => {
        this.products_featured = result.items;
        this.cdr.detectChanges();
      });
    });
  }

  fetchNew() {
    this.offerService.items({ limit: 6, new: true }).pipe(take(1)).subscribe(result => {
      this.zone.run(() => {
        this.products_new = result.items;
        this.zone.run;
        this.cdr.detectChanges();
      });
    });
  }

  fetchCollection() {
      this.offerService.collections({front: true}).pipe(take(1)).subscribe(collections => {
        this.zone.run(() => {
          let i = 0;
          collections.items.forEach(c => {
            if (+c.homepage == 2) {
              this.collection = c;
            } else {
              if (i < 2) {
                this.collections[i] = c;
              }
              i++;
            }
          });
        });
        this.cdr.detectChanges();
        // this.collections = collections.items || null;
      }, error => {
            console.log(error);
      });
  }
  

  setOffer() {
    this.offer = this.offer_temp.filter(o => !o.path.includes('lead-time'));;
    this.cdr.detectChanges();
  }

  pageChanged = (menu: any) => {
    if (Object.keys(menu.menu).length) {
      this.settings = menu.settings;
      this.offer_temp = menu.menu.find(x => x.module === './offer/offer.module#OfferModule').children;
      this.cdr.detectChanges();
    }
  }

  navigate(path, params) {
    let inzone = NgZone.isInAngularZone();
    if (!inzone) { //fix for slider
        this.zone.run(() => {
          // this.pushData();
          this.router.navigate([path], {queryParams: params});
        })
    } else {
      // this.pushData();
      this.router.navigate([path], {queryParams: params});
    }
  }

  getLink(url: string) {
    const res = url.split('?');
    return res[0];
  }
  getParams(queryString: string) {
    const q = {};
    const paramsPart = queryString.split('?')[1];
    if (paramsPart) {
      const pairs = (paramsPart[0] === '?' ? paramsPart.substr(1) : paramsPart).split('&');
      for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split('=');
        q[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
      }
    }
    return q;
  }

  initVideo() {
    // this.video_urls = [{u: this.cdn+'/video/hero_new_720.mp4', w: 1280, h: 720}, {u: this.cdn+'/video/hero_new_720.mp4', w: 1280, h: 720}];
    this.video_urls = [{u: this.cdn+'/video/hero2025_720.mp4', w: 1280, h: 720}, {u: this.cdn+'/video/hero2025_720.mp4', w: 1280, h: 720}];
    this.video = true;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }

  }


}
